import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Box, useStyleConfig} from '@chakra-ui/react'
import NewsletterModal from './newsletter-modal'
import BenefitBar from './benefit-bar'

const PreFooter = ({data}) => {
    const styles = useStyleConfig('PreFooter')

    const {benefit_group, subscribe_group} = data

    // Do not render the entire component if both sections have no data
    if (!benefit_group?.length && !subscribe_group) {
        return null
    }
    return (
        <Stack {...styles.preFooterContainer} data-testid="pre-footer-container">
            {benefit_group?.length > 0 && (
                <Box {...styles.benefitContainer} data-testid="benefit-container">
                    <BenefitBar benefitGroup={benefit_group} />
                </Box>
            )}
            {subscribe_group && (
                <Box {...styles.newsletterContainer} data-testid="newsletter-container">
                    <NewsletterModal subscribeGroup={subscribe_group} />
                </Box>
            )}
        </Stack>
    )
}

PreFooter.propTypes = {
    data: PropTypes.shape({
        benefit_group: PropTypes.array,
        subscribe_group: PropTypes.object,
    }),
}

export default PreFooter
